import { Box } from '@mui/material'
import AiAskBarAttachmentsSection from './AiAskBarAttachmentsSection'
import AiAskBarComposerMainGrid from './AiAskBarComposerMainGrid'
import styles from './index.module.scss'

export default function AiAskBarComposerPanel({
  vm,
  actions,
  replyPreview,
  onDismissReplyPreview,
  mentionMembers,
  mentionAgents,
  onOpenConnections,
  onDiscard,
  sendDisabled,
  onVoiceToggle,
  voiceActive,
}) {
  return (
    <Box className={vm.cardClassName}>
      <Box className={styles.inputPanel}>
        <AiAskBarAttachmentsSection
          replyPreview={replyPreview}
          replySnippet={vm.replySnippet}
          onDismissReplyPreview={onDismissReplyPreview}
          refinementText={vm.refinementText}
          onDismissRefinement={vm.clearRefinement}
          attachments={vm.attachments}
          imageAttachments={vm.imageAttachments}
          docAttachments={vm.docAttachments}
          onRemoveAttachment={actions.handleRemoveAttachment}
          openAttachmentGalleryAtId={vm.openAttachmentGalleryAtId}
        />
        <AiAskBarComposerMainGrid
          vm={vm}
          actions={actions}
          mentionMembers={mentionMembers}
          mentionAgents={mentionAgents}
          onOpenConnections={onOpenConnections}
          onDiscard={onDiscard}
          sendDisabled={sendDisabled}
          onVoiceToggle={onVoiceToggle}
          voiceActive={voiceActive}
        />
      </Box>
    </Box>
  )
}
